/**
 * Form-level API error banner.
 *
 * Renders the form-wide ("non-field") messages a submission failed with — the
 * ones that can't be attributed to a single input, such as a uniqueness clash
 * or a server-side rejection — as one MUI error alert, typically above a form's
 * actions. Field-level errors render inline on their inputs instead; this is
 * the catch-all for everything left over. Feed it the nonFieldMessages that
 * parseApiError / applyApiErrorToFormik hand back.
 *
 * Contains:
 * - FormErrorAlert — the presentational banner (renders null when there's nothing to show)
 */
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import PropTypes from 'prop-types';
import React from 'react';

export default function FormErrorAlert({ messages = [], title, ...alertProps }) {
  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <Alert severity="error" {...alertProps}>
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      {messages.length === 1 ? (
        messages[0]
      ) : (
        <ul style={{ margin: 0, paddingInlineStart: '1.25rem' }}>
          {messages.map((message, index) => (
            <li key={`${index}-${message}`}>{message}</li>
          ))}
        </ul>
      )}
    </Alert>
  );
}

FormErrorAlert.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.node,
};
